var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "450.000000pt",
    viewBox: "0 0 512.000000 450.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,450.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 4474 c-112 -57 -120 -220 -14 -286 36 -22 46 -23 347 -28 296 -5 312 -6 361 -28 63 -28 116 -82 143 -143 12 -26 158 -566 326 -1200 169 -635 320 -1194 337 -1244 106 -312 251 -457 519 -521 68 -16 165 -18 1241 -21 1166 -4 1167 -4 1208 17 64 33 101 109 85 180 -7 34 -54 93 -89 113 -16 9 -302 13 -1196 17 -1098 5 -1179 6 -1228 23 -107 36 -172 123 -238 321 -19 55 -34 101 -34 103 0 1 614 4 1364 5 1361 3 1365 3 1392 24 15 11 36 32 47 46 29 38 460 1790 454 1841 -6 41 -44 99 -80 119 -17 10 -407 14 -1871 18 l-1849 5 -34 124 c-78 285 -208 429 -453 502 -69 20 -100 22 -390 26 -280 3 -319 2 -348 -13z m4484 -1666 l-172 -693 -1316 -3 -1316 -2 -7 27 c-3 16 -85 324 -181 687 -96 362 -174 662 -174 667 0 5 688 9 1668 9 l1669 0 -171 -692z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140 794 c-30 -8 -73 -25 -95 -39 -58 -34 -132 -117 -163 -183 -24 -50 -27 -69 -27 -162 0 -99 2 -110 33 -172 41 -84 128 -167 209 -199 46 -19 78 -23 153 -24 86 0 101 3 162 32 82 39 154 108 191 183 152 312 -128 654 -463 564z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3906 800 c-63 -16 -153 -70 -197 -117 -22 -24 -55 -74 -72 -111 -29 -61 -32 -76 -32 -163 0 -90 2 -99 37 -171 136 -274 494 -307 680 -63 189 248 14 616 -300 631 -42 2 -94 -1 -116 -6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCart);
export default __webpack_public_path__ + "static/media/add-cart.90d8662e.svg";
export { ForwardRef as ReactComponent };